<template>
  <div v-show="isActive" class="brains-scroll-tabs-details--tab"><slot /></div>
</template>

<script>
export default {
  name: 'BrainsScrollTab',
  props: {
    name: {
      type: String,
      required: true
    },
    targetId: {
      type: String,
      default: ''
    },
    selected: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isActive: false
    }
  },
  computed: {},
  mounted() {
    this.isActive = this.selected
  }
}
</script>

<style lang="scss" scoped></style>
